<div>
  <div bsModal #assignInspectorModal="bs-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Assign Inspector</h4>
        </div>
        <div class="modal-body">
          <form [formGroup]="assignInspectorForm">
            <div class="form-group">
              <label for="name">Assign to inspector</label>
              <!-- ng-select component -->
              <ng-select
                [items]="inspectorDataSource"
                bindLabel="name"
                [trackByFn]="inspectorTrackByFn"
                (change)="onInspectorSelect($event)"
                formControlName="inspector"
                s>
                <ng-template ng-option-tmp let-item="item">
                  <div class="d-flex justify-content-between">
                    <span>
                      {{ item.name }}
                      <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                    </span>
                    <span>
                      <small class="pr-6" *ngIf="item.distanceInMiles"
                        >Open Inspections: {{ item.assignmentMadeCount }}</small
                      >
                    </span>
                  </div>
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                  <div>
                    {{ item.name }}
                    <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                  </div>
                </ng-template>
                <ng-template ng-footer-tmp>
                  <a *ngIf="!viewMoreClicked" (click)="viewMoreInspectors()" class="view-more-link">View more</a>
                </ng-template>
                <ng-template ng-not-found> No inspectors found. </ng-template>
              </ng-select>
              <p class="text-danger" *ngIf="inspectorMismatch">
                This Inspector doesn’t match the inspection’s product type. Proceed anyway?
              </p>
            </div>
          </form>
          <br />
          <div style="text-align: right">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Close</button>
            <button type="button" class="btn btn-primary ml-2" (click)="save()">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
